export default __webpack_public_path__ + "static/media/susesi3.c7eddc8c.jpg";